export default "__VITE_ASSET__BwGKTp_R__"